import { inquiryTestIds } from "@/test/testId/inquiryTestIds";
import { serviceTestId } from "./serviceTestId";

export const testIds = {
  home: inquiryTestIds,
  serivce: serviceTestId,
} as const;

type UnpackValuesDeep<T> =
  T extends Record<string, infer U>
    ? UnpackValuesDeep<U>
    : // eslint-disable-next-line @typescript-eslint/no-explicit-any
      T extends (...args: any[]) => infer U
      ? U
      : T;

export type TestId = UnpackValuesDeep<typeof testIds>;

export interface TestIdProps {
  testId?: TestId;
}
